var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.0007V24H4.99932L19.744 9.25534L14.7447 4.25601L0 19.0007ZM23.6101 5.38919C23.7337 5.26586 23.8318 5.11936 23.8987 4.95809C23.9656 4.79681 24 4.62392 24 4.44932C24 4.27472 23.9656 4.10183 23.8987 3.94056C23.8318 3.77928 23.7337 3.63278 23.6101 3.50945L20.4906 0.389872C20.3672 0.266284 20.2207 0.168234 20.0594 0.101335C19.8982 0.0344353 19.7253 0 19.5507 0C19.3761 0 19.2032 0.0344353 19.0419 0.101335C18.8806 0.168234 18.7341 0.266284 18.6108 0.389872L16.1711 2.82954L21.1705 7.82886L23.6101 5.38919Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIco);
export default __webpack_public_path__ + "static/media/PencilIco.b6e699fffd88bdbaaf881631717f3df2.svg";
export { ForwardRef as ReactComponent };